export { CONSENT_CHANGED_BROADCAST_EVENT } from '../model/contants'
export type { BroadcastPort } from '../ports'

import { BroadcastAdapter } from '../adapters'
import { BroadcastPort } from '../ports'
export const broadcaster: BroadcastPort = new BroadcastAdapter()
